// ── กิจกรรมและผลลัพธ์การขับเคลื่อนคลัสเตอร์ ──

// รูปภาพกิจกรรม (image001–image044)
export const clusterActivityImages = [
  'https://iili.io/qFAZ3Hg.jpg', // image001
  'https://iili.io/qFAZdUF.jpg', // image002
  'https://iili.io/qFAZFRa.jpg', // image003
  'https://iili.io/qFAZHKP.jpg', // image004
  'https://iili.io/qFAZKOJ.jpg', // image005
  'https://iili.io/qFAZfDv.jpg', // image006
  'https://iili.io/qFAZBxR.jpg', // image007
  'https://iili.io/qFAZCVp.jpg', // image008
  'https://iili.io/qFAZniN.jpg', // image009
  'https://iili.io/qFAZxfI.jpg', // image010
  'https://iili.io/qFAZzlt.jpg', // image011
  'https://iili.io/qFAZIUX.jpg', // image012
  'https://iili.io/qFAZuJn.jpg', // image013
  'https://iili.io/qFAZARs.jpg', // image014
  'https://iili.io/qFAZROG.jpg', // image015
  'https://iili.io/qFAZ5bf.jpg', // image016
  'https://iili.io/qFAZYx4.jpg', // image017
  'https://iili.io/qFAZaWl.jpg', // image018
  'https://iili.io/qFAZcs2.jpg', // image019
  'https://iili.io/qFAZ0fS.jpg', // image020
  'https://iili.io/qFAZ107.jpg', // image021
  'https://iili.io/qFAZEg9.jpg', // image022
  'https://iili.io/qFAZMJe.jpg', // image023
  'https://iili.io/qFAZV5u.jpg', // image024
  'https://iili.io/qFAZXbj.jpg', // image025
  'https://iili.io/qFAZWOb.jpg', // image026
  'https://iili.io/qFAZjzx.jpg', // image027
  'https://iili.io/qFAZwWQ.jpg', // image028
  'https://iili.io/qFAZNsV.jpg', // image029
  'https://iili.io/qFAZeqB.jpg', // image030
  'https://iili.io/qFAZk0P.jpg', // image031
  'https://iili.io/qFAZvg1.jpg', // image032
  'https://iili.io/qFAZSdF.jpg', // image033
  'https://iili.io/qFAZgea.jpg', // image034
  'https://iili.io/qFAZrmJ.jpg', // image035
  'https://iili.io/qFAZ6zv.jpg', // image036
  'https://iili.io/qFAZPXR.jpg', // image037
  'https://iili.io/qFAZisp.jpg', // image038
  'https://iili.io/qFAZZgt.jpg', // image039
  'https://iili.io/qFAZDdX.jpg', // image040
  'https://iili.io/qFAZQ1I.jpg', // image041
  'https://iili.io/qFAZb7n.jpg', // image042
  'https://iili.io/qFAZmes.jpg', // image043
  'https://iili.io/qFAZpmG.jpg', // image044
]

// ข่าว SIE 20 ฉบับ พร้อมรูปภาพประกอบแต่ละข่าว
export const newsItems = [
  {
    id: 1,
    title: 'ไทย–ซาอุฯ จับมือครั้งสำคัญ เปิดประตู SME ไทยสู่ตลาดซาอุดีอาระเบีย ผ่าน "Cluster SIE"',
    content: `เมื่อวันที่ 9 มกราคม 2569 ณ ชั้น 19 อาคารเกษรทาวเวอร์ ถนนราชดำริ กรุงเทพมหานคร สมาพันธ์เอสเอ็มอีไทย (Federation of Thai SMEs) และสภาธุรกิจซาอุดีอาระเบีย–ไทย (Saudi–Thai Business Council) ได้ร่วมลงนามบันทึกข้อตกลงความร่วมมือ (MOU) เชิงยุทธศาสตร์ เพื่อส่งเสริมความร่วมมือด้านการค้าและการลงทุน และเปิดโอกาสใหม่ให้ผู้ประกอบการ SME ไทยเข้าสู่ตลาดราชอาณาจักรซาอุดีอาระเบียอย่างเป็นรูปธรรม ภายใต้โครงการ "Cluster SIE (Social Integrated Enterprise)"

ความร่วมมือครั้งนี้มีเป้าหมายเพื่อพัฒนาศักยภาพ SME ไทยให้สามารถแข่งขันในตลาดนานาชาติได้อย่างยั่งยืน โดยเฉพาะตลาดซาอุดีอาระเบีย ซึ่งกำลังขยายตัวอย่างรวดเร็วภายใต้นโยบาย Saudi Vision 2030

Mr. Osama Kokandy ประธานสภาธุรกิจซาอุดีอาระเบีย–ไทย กล่าวว่า MOU ฉบับนี้ถือเป็นจุดเริ่มต้นของความร่วมมือระยะยาว โดยธุรกิจไทยมีจุดแข็งด้านคุณภาพ มาตรฐาน และความยืดหยุ่น ซึ่งสอดคล้องกับความต้องการของตลาดซาอุดีอาระเบีย

ด้าน ดร.ณพพงศ์ ธีระวร ประธานสมาพันธ์เอสเอ็มอีไทย ระบุว่า การเชื่อมโยงผ่าน Cluster SIE จะช่วยให้ SME ไทยรวมกลุ่ม สร้างมาตรฐาน และขยายตลาดต่างประเทศได้อย่างมีระบบ

ความร่วมมือดังกล่าวครอบคลุมการจับคู่ธุรกิจ การสนับสนุนด้านกฎระเบียบ การพัฒนาองค์ความรู้ และการลงทุนในสาขาอาหาร สุขภาพ โลจิสติกส์ การผลิต ดิจิทัล และการท่องเที่ยว`,
    images: [
      'https://iili.io/qFAZCVp.jpg', // image008
      'https://iili.io/qFAZ0fS.jpg', // image020
      'https://iili.io/qFAZeqB.jpg', // image030
      'https://iili.io/qFAZ6zv.jpg', // image036
      'https://iili.io/qFAZmes.png', // Screenshot 2569-02-22 at 12.47.48
    ]
  },
  {
    id: 2,
    title: 'เปิดเกมรุก SME ไทย บุกตลาดซาอุฯ อย่างเป็นระบบ',
    content: `สมาพันธ์เอสเอ็มอีไทยลงนาม MOU กับสภาธุรกิจซาอุดีอาระเบีย–ไทย ณ อาคารเกษรทาวเวอร์ กรุงเทพฯ เพื่อสร้างกลไกสนับสนุน SME ไทยสู่ตลาดซาอุดีอาระเบีย ภายใต้โมเดล Cluster SIE

พิธีลงนามจัดขึ้นเมื่อวันที่ 9 มกราคม 2569 โดยมีผู้นำองค์กรทั้งสองฝ่ายเข้าร่วม สะท้อนถึงความมุ่งมั่นร่วมกันในการยกระดับความร่วมมือทางเศรษฐกิจไทย–ซาอุฯ

Cluster SIE จะทำหน้าที่เป็นกลไกกลาง เชื่อมงานวิจัย องค์ความรู้ และภาคธุรกิจ เพื่อให้ SME ไทยสามารถรวมกลุ่ม สร้างมาตรฐาน และลดความเสี่ยงก่อนเข้าสู่ตลาดต่างประเทศ

ความร่วมมือครั้งนี้คาดว่าจะช่วยเพิ่มโอกาสทางการค้าในกลุ่มอาหารและเครื่องดื่ม ฮาลาล สุขภาพ โลจิสติกส์ และบริการดิจิทัล รองรับความต้องการของตลาดซาอุดีอาระเบียที่เติบโตต่อเนื่อง`,
    images: [
      'https://iili.io/qFAZ3Hg.jpg', // image001
      'https://iili.io/qFAZfDv.jpg', // image006
      'https://iili.io/qFAZBxR.jpg', // image007
      'https://iili.io/qFAZCVp.jpg', // image008
    ]
  },
  {
    id: 3,
    title: 'Cluster SIE สะพานเศรษฐกิจไทย–ซาอุฯ',
    content: `วันที่ 9 มกราคม 2569 สมาพันธ์เอสเอ็มอีไทย และสภาธุรกิจซาอุดีอาระเบีย–ไทย ร่วมลงนาม MOU เชิงยุทธศาสตร์ เพื่อผลักดัน SME ไทยเข้าสู่ตลาดซาอุดีอาระเบีย

ความร่วมมือครั้งนี้มุ่งใช้ "Cluster SIE" เป็นแพลตฟอร์มรวมกลุ่มผู้ประกอบการ พัฒนามาตรฐาน และเชื่อมโยงตลาดต่างประเทศอย่างยั่งยืน

Mr. Osama Kokandy กล่าวว่า ตลาดซาอุดีอาระเบียมีศักยภาพสูง และต้องการพันธมิตรทางธุรกิจที่มีคุณภาพจากประเทศไทย

ขณะที่ฝ่ายไทยยืนยันว่า โมเดล SIE จะช่วยเสริมความพร้อมของ SME ในด้านคุณภาพสินค้า การบริหารจัดการ และการเข้าถึงเครือข่ายตลาด`,
    images: [
      'https://iili.io/qFAZfDv.jpg', // image006
      'https://iili.io/qFAZBxR.jpg', // image007
      'https://iili.io/qFAZ107.jpg', // image021
      'https://iili.io/qFAZEg9.jpg', // image022
      'https://iili.io/qFAZmes.png', // Screenshot 2569-02-22 at 12.47.48
    ]
  },
  {
    id: 4,
    title: 'ไทยตอบรับ Vision 2030 ผ่านความร่วมมือ SME เปิดตลาดตะวันออกกลางอย่างเป็นระบบ',
    content: `สมาพันธ์เอสเอ็มอีไทย ลงนามบันทึกข้อตกลงความร่วมมือ (MOU) กับสภาธุรกิจซาอุดีอาระเบีย–ไทย ณ กรุงเทพมหานคร เพื่อเปิดประตูผู้ประกอบการไทยเข้าสู่ตลาดซาอุดีอาระเบีย ภายใต้กรอบยุทธศาสตร์ Saudi Vision 2030 ซึ่งมุ่งปรับโครงสร้างเศรษฐกิจซาอุดีอาระเบียให้หลากหลายและยั่งยืนมากยิ่งขึ้น

พิธีลงนามจัดขึ้นเมื่อวันที่ 9 มกราคม 2569 ณ อาคารเกษรทาวเวอร์ โดยมีผู้แทนระดับสูงจากทั้งสององค์กรเข้าร่วมอย่างพร้อมเพรียง สะท้อนถึงความมุ่งมั่นร่วมกันในการผลักดันความร่วมมือด้านการค้า การลงทุน และการพัฒนาผู้ประกอบการ SME ไทยให้สามารถแข่งขันในตลาดตะวันออกกลางได้อย่างมีศักยภาพ

ความร่วมมือครั้งนี้ครอบคลุมการจับคู่ธุรกิจ (Business Matching) การแลกเปลี่ยนองค์ความรู้ด้านกฎระเบียบ มาตรฐาน และวัฒนธรรมทางธุรกิจ ตลอดจนการสนับสนุนข้อมูลตลาดและเครือข่ายพันธมิตรในซาอุดีอาระเบีย

โครงการ "Cluster SIE (Social Integrated Enterprise)" จะทำหน้าที่เป็นกลไกหลักในการรวมกลุ่มผู้ประกอบการ พัฒนามาตรฐานสินค้า และสร้างความพร้อมเชิงระบบ เพื่อให้ SME ไทยสามารถขยายตลาดสู่ระดับสากลได้อย่างมั่นคงและยั่งยืน`,
    images: [
      'https://iili.io/qFAZCVp.jpg', // image008
      'https://iili.io/qFAZniN.jpg', // image009
      'https://iili.io/qFAZzlt.jpg', // image011
      'https://iili.io/qFAZgea.jpg', // image034
      'https://iili.io/qFAZ6zv.jpg', // image036
    ]
  },
  {
    id: 5,
    title: 'MOU ไทย–ซาอุฯ สร้างโอกาสการค้าใหม่ให้ SME ไทย ภายใต้กลไก Cluster SIE',
    content: `สององค์กรธุรกิจสำคัญของไทยและซาอุดีอาระเบีย ได้แก่ สมาพันธ์เอสเอ็มอีไทย และสภาธุรกิจซาอุดีอาระเบีย–ไทย ร่วมลงนาม MOU เชิงยุทธศาสตร์ ณ อาคารเกษรทาวเวอร์ กรุงเทพฯ เพื่อเสริมสร้างความร่วมมือทางการค้าและการลงทุนระหว่างสองประเทศ

ความร่วมมือดังกล่าวมีเป้าหมายสนับสนุนสมาชิกของทั้งสองฝ่ายในด้านการจับคู่ธุรกิจ การให้ข้อมูลเชิงลึกเกี่ยวกับตลาดซาอุดีอาระเบีย การสนับสนุนด้านกฎระเบียบ และการเชื่อมโยงเครือข่ายนักลงทุนในภูมิภาคตะวันออกกลาง

Cluster SIE จะทำหน้าที่เป็นระบบบริหารจัดการคลัสเตอร์ที่เชื่อมโยงผู้ประกอบการไทยเข้ากับตลาดต่างประเทศอย่างเป็นระบบ ลดความเสี่ยงในการเข้าสู่ตลาดใหม่ และเพิ่มอำนาจต่อรองให้กับ SME ไทยผ่านการรวมกลุ่มและยกระดับมาตรฐานสินค้า

การลงนามครั้งนี้จึงถือเป็นอีกก้าวสำคัญในการขยายบทบาทของ SME ไทยในเวทีการค้าระดับโลก`,
    images: [
        'https://iili.io/qFAZzlt.jpg', // image011
      'https://iili.io/qFAZ3Hg.jpg', // image001
      'https://iili.io/qFAZXbj.jpg', // image025
      'https://iili.io/qFAZBxR.jpg', // image007
      
      'https://iili.io/qFAZgea.jpg', // image034
    ]
  },
  {
    id: 6,
    title: 'ก้าวสำคัญของ SME ไทยสู่ตะวันออกกลาง เปิดโอกาสใหม่ในตลาดซาอุดีอาระเบีย',
    content: `วันที่ 9 มกราคม 2569 นับเป็นหมุดหมายสำคัญของความร่วมมือทางเศรษฐกิจไทย–ซาอุฯ เมื่อสมาพันธ์เอสเอ็มอีไทย และสภาธุรกิจซาอุดีอาระเบีย–ไทย ได้ลงนาม MOU เพื่อเปิดช่องทางใหม่ให้ SME ไทยเข้าสู่ตลาดซาอุดีอาระเบียอย่างเป็นรูปธรรม

เป้าหมายหลักของความร่วมมือคือการสนับสนุนผู้ประกอบการไทยในสาขาที่มีศักยภาพสูง ได้แก่ อาหารและเครื่องดื่ม ฮาลาล สุขภาพ โลจิสติกส์ การผลิต และบริการดิจิทัล ซึ่งสอดคล้องกับทิศทางการพัฒนาเศรษฐกิจของซาอุดีอาระเบียภายใต้ Vision 2030

โมเดล Cluster SIE จะช่วยรวมกลุ่มผู้ประกอบการไทย สร้างมาตรฐานคุณภาพสินค้า และพัฒนาศักยภาพการแข่งขัน เพื่อให้สามารถเข้าสู่ตลาดต่างประเทศได้อย่างมั่นคง พร้อมทั้งลดความเสี่ยงจากการแข่งขันที่รุนแรงในตลาดโลก`,
    images: [
      'https://iili.io/qFAZXbj.jpg', // image025
      'https://iili.io/qFAZfDv.jpg', // image006
      'https://iili.io/qFAZCVp.jpg', // image008
      'https://iili.io/qFAZuJn.jpg', // image013
      'https://iili.io/qFAZisp.jpg', // image038
    ]
  },
  {
    id: 7,
    title: 'สร้างเครือข่ายธุรกิจไทย–ซาอุฯ ผ่าน Cluster SIE ขับเคลื่อน SME สู่เวทีสากล',
    content: `สมาพันธ์เอสเอ็มอีไทยเดินหน้าขยายตลาดต่างประเทศ ด้วยการลงนาม MOU กับสภาธุรกิจซาอุดีอาระเบีย–ไทย เพื่อสร้างเครือข่ายธุรกิจระหว่างสองประเทศอย่างเป็นระบบ

ความร่วมมือครั้งนี้เน้นการพัฒนาเชิงระบบมากกว่ากิจกรรมระยะสั้น โดยใช้ Cluster SIE เป็นแพลตฟอร์มกลางในการเชื่อมโยงผู้ประกอบการไทยกับตลาดซาอุดีอาระเบีย ผ่านการยกระดับมาตรฐานสินค้า การบริหารความเสี่ยง และการพัฒนาองค์ความรู้ด้านการค้าระหว่างประเทศ

ผู้ประกอบการไทยจะได้รับการสนับสนุนทั้งด้านข้อมูลตลาด การจับคู่ธุรกิจ และการสร้างเครือข่ายพันธมิตร เพื่อเพิ่มโอกาสในการขยายธุรกิจสู่ภูมิภาคตะวันออกกลางอย่างยั่งยืน`,
    images: [
      'https://iili.io/qFAZBxR.jpg', // image007
      'https://iili.io/qFAZ107.jpg', // image021
      'https://iili.io/qFAZEg9.jpg', // image022
      'https://iili.io/qFAZMJe.jpg', // image023
      'https://iili.io/qFAZjzx.jpg', // image027
    ]
  },
  {
    id: 8,
    title: 'ไทย–ซาอุฯ เดินหน้าความร่วมมือการค้าอย่างยั่งยืน ภายใต้กรอบ Cluster SIE',
    content: `พิธีลงนาม MOU ระหว่างสมาพันธ์เอสเอ็มอีไทย และสภาธุรกิจซาอุดีอาระเบีย–ไทย จัดขึ้น ณ กรุงเทพมหานคร เพื่อยกระดับความร่วมมือด้านเศรษฐกิจและการลงทุนระหว่างสองประเทศ

ความร่วมมือดังกล่าวจะช่วยให้ SME ไทยเข้าถึงตลาดซาอุดีอาระเบียผ่านกลไก Cluster SIE ซึ่งมุ่งเน้นการรวมกลุ่มผู้ประกอบการ พัฒนามาตรฐานสินค้า และสร้างระบบสนับสนุนเชิงโครงสร้างที่ช่วยลดความเสี่ยงในการเข้าสู่ตลาดใหม่

ทั้งสองฝ่ายเชื่อมั่นว่าการร่วมมือครั้งนี้จะสร้างประโยชน์ทางเศรษฐกิจระยะยาวแก่ผู้ประกอบการทั้งสองประเทศ และเสริมสร้างความสัมพันธ์ทางการค้าไทย–ซาอุฯ ให้แข็งแกร่งยิ่งขึ้น`,
    images: [
      'https://iili.io/qFAZjzx.jpg', // image027
      'https://iili.io/qFAZgea.jpg', // image034
      'https://iili.io/qFAZmes.jpg', // image043
      'https://iili.io/qFAZmes.png', // Screenshot 2569-02-22 at 12.47.48
      'https://iili.io/qFAZpmG.png', // Screenshot 2569-02-22 at 12.51.26
    ]
  },
  {
    id: 9,
    title: 'เสริมพลัง SME ไทย บุกตลาดซาอุดีอาระเบีย รองรับโอกาส Vision 2030',
    content: `สมาพันธ์เอสเอ็มอีไทย และสภาธุรกิจซาอุดีอาระเบีย–ไทย ลงนามความร่วมมือเชิงยุทธศาสตร์ เพื่อส่งเสริมการค้าและการลงทุนระหว่างสองประเทศ เปิดโอกาสให้ SME ไทยเข้าสู่ตลาดซาอุดีอาระเบียอย่างเป็นระบบ

Cluster SIE จะทำหน้าที่เตรียมความพร้อมให้ผู้ประกอบการไทย ทั้งในด้านมาตรฐานสินค้า การบริหารจัดการ การสร้างเครือข่ายธุรกิจ และการเข้าถึงข้อมูลตลาดเชิงลึก

ตลาดซาอุดีอาระเบียถือเป็นตลาดยุทธศาสตร์ที่มีศักยภาพสูง โดยเฉพาะในกลุ่มสินค้าอาหาร ฮาลาล สุขภาพ และการท่องเที่ยว ซึ่งสอดคล้องกับทิศทางการพัฒนาเศรษฐกิจของประเทศภายใต้ Vision 2030`,
    images: [
      'https://iili.io/qFAZ3Hg.jpg', // image001
      'https://iili.io/qFAZFRa.jpg', // image003
      'https://iili.io/qFAZ0fS.jpg', // image020
      'https://iili.io/qFAZeqB.jpg', // image030
      'https://iili.io/qFAZQ1I.jpg', // image041
    ]
  },
  {
    id: 10,
    title: 'ไทย–ซาอุฯ เปิดบทใหม่ความร่วมมือ SME ยกระดับการค้าและการลงทุน',
    content: `การลงนาม MOU เมื่อวันที่ 9 มกราคม 2569 ระหว่างสมาพันธ์เอสเอ็มอีไทย และสภาธุรกิจซาอุดีอาระเบีย–ไทย ถือเป็นอีกก้าวสำคัญของความสัมพันธ์ทางเศรษฐกิจไทย–ซาอุฯ

ทั้งสององค์กรจะร่วมกันผลักดันผู้ประกอบการไทยสู่ตลาดต่างประเทศ ผ่านกลไก Cluster SIE ซึ่งออกแบบให้เป็นระบบสนับสนุนการพัฒนาเชิงคลัสเตอร์ ลดความเสี่ยง และเพิ่มศักยภาพการแข่งขันของ SME ไทย

ความร่วมมือครอบคลุมการจับคู่ธุรกิจ การพัฒนาองค์ความรู้ การสนับสนุนด้านกฎระเบียบ และการส่งเสริมการลงทุนในสาขาสำคัญ อาทิ อาหาร สุขภาพ โลจิสติกส์ ดิจิทัล และการท่องเที่ยว

การลงนามครั้งนี้สะท้อนถึงความตั้งใจร่วมกันในการสร้างโอกาสทางเศรษฐกิจใหม่ ๆ และเสริมสร้างความร่วมมือที่ยั่งยืนระหว่างสองประเทศในระยะยาว`,
    images: [
      'https://iili.io/qFAZzlt.jpg', // image011
      'https://iili.io/qFAZ107.jpg', // image021
      'https://iili.io/qFAZEg9.jpg', // image022
      'https://iili.io/qFAZjzx.jpg', // image027
      'https://iili.io/qFAZDdX.jpg', // image040
    ]
  },
  {
    id: 11,
    title: 'ไทย–ซาอุฯ ขับเคลื่อนความร่วมมือเศรษฐกิจใหม่ ผ่านกลไกคลัสเตอร์ SIE',
    content: `เมื่อวันที่ 9 มกราคม 2569 ณ อาคารเกษรทาวเวอร์ กรุงเทพมหานคร สมาพันธ์เอสเอ็มอีไทย นำโดย ดร.ณพพงศ์ ธีระวร ประธานสมาพันธ์เอสเอ็มอีไทย ได้ร่วมลงนามบันทึกข้อตกลงความร่วมมือ (MOU) เชิงยุทธศาสตร์กับสภาธุรกิจซาอุดีอาระเบีย–ไทย นำโดย Mr. Osama Kokandy ประธานสภาธุรกิจซาอุดีอาระเบีย–ไทย

ความร่วมมือดังกล่าวมีเป้าหมายเพื่อเปิดโอกาสให้ผู้ประกอบการ SME ไทยสามารถเข้าสู่ตลาดราชอาณาจักรซาอุดีอาระเบียได้อย่างเป็นระบบ ภายใต้กรอบ Vision 2030 โดยมี Cluster SIE (Social Integrated Enterprise) เป็นกลไกกลางในการรวมกลุ่มและยกระดับมาตรฐานสินค้า

คุณสมประสงค์ พยัคฆพันธ์ รองประธานสมาพันธ์เอสเอ็มอีไทย และหัวหน้าโครงการ Cluster SIE กล่าวว่า โมเดล SIE จะช่วยเชื่อมโยงงานวิจัย องค์ความรู้ และภาคธุรกิจ เพื่อสร้างระบบสนับสนุนผู้ประกอบการตั้งแต่ต้นน้ำถึงปลายน้ำอย่างยั่งยืน`,
    images: [
      'https://iili.io/qFAZ3Hg.jpg', // image001
      'https://iili.io/qFAZdUF.jpg', // image002
      'https://iili.io/qFAZFRa.jpg', // image003
      'https://iili.io/qFAZHKP.jpg', // image004
      'https://iili.io/qFAZKOJ.jpg', // image005
    ]
  },
  {
    id: 12,
    title: 'MOU ไทย–ซาอุฯ สร้างสะพานเศรษฐกิจใหม่ เชื่อม SME ไทยสู่ตะวันออกกลาง',
    content: `สมาพันธ์เอสเอ็มอีไทย ภายใต้การนำของ ดร.ณพพงศ์ ธีระวร และสภาธุรกิจซาอุดีอาระเบีย–ไทย ภายใต้การนำของ Mr. Osama Kokandy ได้ลงนามความร่วมมือเพื่อเสริมสร้างความเชื่อมโยงทางการค้าและการลงทุนระหว่างสองประเทศ

ดร.ณพพงศ์ กล่าวว่า ความร่วมมือครั้งนี้สะท้อนบทบาทของสมาพันธ์ฯ ในการผลักดัน SME ไทยให้สามารถแข่งขันในตลาดนานาชาติ ขณะที่ Mr. Kokandy ระบุว่าธุรกิจไทยมีศักยภาพสูงด้านคุณภาพ มาตรฐาน และความยืดหยุ่น ซึ่งสอดคล้องกับความต้องการของตลาดซาอุดีอาระเบีย

ด้าน คุณสมประสงค์ พยัคฆพันธ์ ชี้ว่า Cluster SIE จะเป็นแพลตฟอร์มกลางในการจัดการคลัสเตอร์ผู้ประกอบการ เพื่อเพิ่มอำนาจต่อรองและลดความเสี่ยงในการเข้าสู่ตลาดต่างประเทศ`,
    images: [
      'https://iili.io/qFAZfDv.jpg', // image006
      'https://iili.io/qFAZBxR.jpg', // image007
      'https://iili.io/qFAZCVp.jpg', // image008
      'https://iili.io/qFAZniN.jpg', // image009
      'https://iili.io/qFAZxfI.jpg', // image010
    ]
  },
  {
    id: 13,
    title: 'เปิดตลาดใหม่ให้ SME ไทย ผ่านความร่วมมือเชิงยุทธศาสตร์ไทย–ซาอุฯ',
    content: `พิธีลงนาม MOU ระหว่างสมาพันธ์เอสเอ็มอีไทย และสภาธุรกิจซาอุดีอาระเบีย–ไทย จัดขึ้นอย่างเป็นทางการ โดยมี ดร.ณพพงศ์ ธีระวร และ Mr. Osama Kokandy ร่วมลงนาม

ความร่วมมือดังกล่าวจะสนับสนุนสมาชิกทั้งสองฝ่ายในด้าน Business Matching การให้ข้อมูลตลาด และการสนับสนุนด้านกฎระเบียบ เพื่อให้ SME ไทยสามารถเข้าถึงตลาดซาอุฯ ได้อย่างมั่นคง

คุณสมประสงค์ พยัคฆพันธ์ ระบุว่า โครงการ Cluster SIE ซึ่งได้รับการสนับสนุนจากหน่วยบริหารและจัดการทุนด้านการพัฒนาระดับพื้นที่ (บพท.) ถูกออกแบบเพื่อยกระดับผู้ประกอบการฐานรากให้สามารถรวมกลุ่ม สร้างมาตรฐาน และขยายตลาดสู่ต่างประเทศได้อย่างเป็นรูปธรรม`,
    images: [
      'https://iili.io/qFAZBxR.jpg', // image007
      'https://iili.io/qFAZzlt.jpg', // image011
      'https://iili.io/qFAZIUX.jpg', // image012
      'https://iili.io/qFAZuJn.jpg', // image013
      'https://iili.io/qFAZARs.jpg', // image014
    ]
  },
  {
    id: 14,
    title: 'ไทย–ซาอุฯ ผนึกกำลังผลักดัน SME สู่เวทีสากล',
    content: `การลงนามความร่วมมือระหว่างสององค์กรธุรกิจสำคัญ นำโดย ดร.ณพพงศ์ ธีระวร และ Mr. Osama Kokandy ถือเป็นก้าวสำคัญของความสัมพันธ์ทางเศรษฐกิจไทย–ซาอุฯ

ดร.ณพพงศ์ กล่าวว่าตลาดซาอุดีอาระเบียเป็นตลาดยุทธศาสตร์ที่มีศักยภาพสูง ขณะที่ Mr. Kokandy ยืนยันความพร้อมของภาคธุรกิจซาอุฯ ในการร่วมมือกับผู้ประกอบการไทยในระยะยาว

คุณสมประสงค์ พยัคฆพันธ์ เสริมว่า Cluster SIE จะช่วยออกแบบระบบบริหารจัดการคลัสเตอร์ เพื่อให้การขยายตลาดไม่ใช่เพียงกิจกรรมระยะสั้น แต่เป็นการพัฒนาเชิงระบบที่ยั่งยืน`,
    images: [
      'https://iili.io/qFAZROG.jpg', // image015
      'https://iili.io/qFAZ5bf.jpg', // image016
      'https://iili.io/qFAZYx4.jpg', // image017
      'https://iili.io/qFAZaWl.jpg', // image018
      'https://iili.io/qFAZk0P.jpg', // image031
    ]
  },
  {
    id: 15,
    title: 'Cluster SIE กลไกหลักพา SME ไทยสู่ตลาดซาอุดีอาระเบีย',
    content: `สมาพันธ์เอสเอ็มอีไทย โดย ดร.ณพพงศ์ ธีระวร ร่วมกับสภาธุรกิจซาอุดีอาระเบีย–ไทย โดย Mr. Osama Kokandy ได้ลงนาม MOU เพื่อสนับสนุนผู้ประกอบการไทยสู่ตลาดตะวันออกกลาง

ความร่วมมือจะเน้นการพัฒนาศักยภาพ SME ในกลุ่มอุตสาหกรรมสำคัญ เช่น อาหารและเครื่องดื่ม ฮาลาล สุขภาพ โลจิสติกส์ และบริการดิจิทัล

คุณสมประสงค์ พยัคฆพันธ์ กล่าวว่า Cluster SIE จะทำหน้าที่เป็น "กลไกกลาง" ในการเชื่อมรัฐ ตลาด และชุมชน เพื่อให้การเติบโตของ SME ไทยเกิดขึ้นอย่างมั่นคง และสามารถแข่งขันในระดับสากลได้`,
    images: [
      'https://iili.io/qFAZfDv.jpg', // image006
      'https://iili.io/qFAZARs.jpg', // image014
      'https://iili.io/qFAZ107.jpg', // image021
      'https://iili.io/qFAZEg9.jpg', // image022
    ]
  },
  {
    id: 16,
    title: 'ไทย–ซาอุฯ วางรากฐานความร่วมมือระยะยาว ยกระดับ SME ไทยสู่ตลาดยุทธศาสตร์ตะวันออกกลาง',
    content: `เมื่อวันที่ 9 มกราคม 2569 ณ อาคารเกษรทาวเวอร์ กรุงเทพมหานคร สมาพันธ์เอสเอ็มอีไทย (Federation of Thai SMEs) นำโดย ดร.ณพพงศ์ ธีระวร ประธานสมาพันธ์เอสเอ็มอีไทย และ คุณสมประสงค์ พยัคฆพันธ์ รองประธานสมาพันธ์เอสเอ็มอีไทย และหัวหน้าโครงการ Cluster SIE ได้ร่วมลงนามบันทึกข้อตกลงความร่วมมือ (MOU) กับ Mr. Osama Kokandy ประธานสภาธุรกิจซาอุดีอาระเบีย–ไทย (Saudi–Thai Business Council) เพื่อขับเคลื่อนความร่วมมือด้านการค้า การลงทุน และการพัฒนา SME ไทยเข้าสู่ตลาดซาอุดีอาระเบียอย่างเป็นระบบ

ความร่วมมือดังกล่าวมุ่งเน้นการสร้าง "ระบบรองรับการเติบโต" ให้ SME ไทย ไม่ใช่เพียงการส่งออกสินค้าแบบรายครั้ง โดยใช้กลไก Cluster SIE (Social Integrated Enterprise) เป็นแพลตฟอร์มกลางในการรวมกลุ่มผู้ประกอบการ พัฒนามาตรฐานสินค้า และจัดทำ Business Matching เชิงลึกกับภาคธุรกิจซาอุดีอาระเบีย`,
    images: [
      'https://iili.io/qFAZniN.jpg', // image009
      'https://iili.io/qFAZfDv.jpg', // image006
      'https://iili.io/qFAZBxR.jpg', // image007
      'https://iili.io/qFAZARs.jpg', // image014
      'https://iili.io/qFAZgea.jpg', // image034
    ]
  },
  {
    id: 17,
    title: 'เปิดประตูการค้าใหม่ ไทย–ซาอุฯ เดินหน้าความร่วมมือเชิงระบบผ่าน Cluster SIE',
    content: `พิธีลงนาม MOU ระหว่างสมาพันธ์เอสเอ็มอีไทย และสภาธุรกิจซาอุดีอาระเบีย–ไทย ถือเป็นอีกก้าวสำคัญของความสัมพันธ์ทางเศรษฐกิจระหว่างสองประเทศ ภายใต้การนำของ ดร.ณพพงศ์ ธีระวร และ Mr. Osama Kokandy

ในโอกาสนี้ คุณสมประสงค์ พยัคฆพันธ์ กล่าวว่า โครงการ Cluster SIE ได้รับการพัฒนาบนฐานงานวิจัยและการจัดการเชิงคลัสเตอร์ เพื่อเสริมศักยภาพ SME ไทยให้สามารถรวมกลุ่ม สร้างมาตรฐาน และบริหารความเสี่ยงในการเข้าสู่ตลาดต่างประเทศได้อย่างมั่นคง

ตลาดซาอุดีอาระเบียซึ่งเป็นหนึ่งในประเทศสำคัญภายใต้นโยบาย Vision 2030 มีความต้องการสินค้าและบริการคุณภาพสูงจากต่างประเทศ โดยเฉพาะกลุ่มอาหารฮาลาล สุขภาพ โลจิสติกส์ และเทคโนโลยีดิจิทัล ซึ่ง SME ไทยมีศักยภาพตอบโจทย์ได้อย่างชัดเจน`,
    images: [
      'https://iili.io/qFAZ3Hg.jpg', // image001
      'https://iili.io/qFAZFRa.jpg', // image003
      'https://iili.io/qFAZjzx.jpg', // image027
      'https://iili.io/qFAZwWQ.jpg', // image028
      'https://iili.io/qFAZeqB.jpg', // image030
    ]
  },
  {
    id: 18,
    title: 'Cluster SIE ขับเคลื่อนยุทธศาสตร์เศรษฐกิจฐานรากไทย เชื่อมตลาดซาอุดีอาระเบีย',
    content: `การลงนามความร่วมมือครั้งนี้ ไม่ได้เป็นเพียงข้อตกลงเชิงพิธีการ แต่เป็นการวางกลไกการทำงานร่วมกันระหว่างสององค์กรธุรกิจหลัก ได้แก่ สมาพันธ์เอสเอ็มอีไทย นำโดย ดร.ณพพงศ์ ธีระวร และสภาธุรกิจซาอุดีอาระเบีย–ไทย นำโดย Mr. Osama Kokandy

ภายใต้กรอบความร่วมมือดังกล่าว จะมีการจัดกิจกรรมจับคู่ธุรกิจ การให้ข้อมูลเชิงลึกด้านกฎระเบียบการนำเข้า–ส่งออก และการสนับสนุนด้านมาตรฐานสินค้า เพื่อให้ SME ไทยสามารถปรับตัวและแข่งขันได้ในตลาดตะวันออกกลาง

คุณสมประสงค์ พยัคฆพันธ์ ระบุว่า Cluster SIE จะทำหน้าที่เป็นตัวกลางในการบริหารจัดการคลัสเตอร์ และสร้างความพร้อมให้ผู้ประกอบการตั้งแต่ระดับชุมชนไปจนถึงระดับอุตสาหกรรม`,
    images: [
      'https://iili.io/qFAZfDv.jpg', // image006
      'https://iili.io/qFAZvg1.jpg', // image032
      'https://iili.io/qFAZSdF.jpg', // image033
      'https://iili.io/qFAZgea.jpg', // image034
      'https://iili.io/qFAZQ1I.jpg', // image041
    ]
  },
  {
    id: 19,
    title: 'ไทย–ซาอุฯ ขยายความร่วมมือเศรษฐกิจ มุ่งสร้างโอกาสการลงทุนและการค้าใหม่',
    content: `ณ อาคารเกษรทาวเวอร์ กรุงเทพมหานคร ได้มีการลงนาม MOU ระหว่างสมาพันธ์เอสเอ็มอีไทย โดย ดร.ณพพงศ์ ธีระวร และ คุณสมประสงค์ พยัคฆพันธ์ กับสภาธุรกิจซาอุดีอาระเบีย–ไทย นำโดย Mr. Osama Kokandy เพื่อยกระดับความร่วมมือทางเศรษฐกิจอย่างเป็นรูปธรรม

ความร่วมมือครอบคลุมการสนับสนุนสมาชิกทั้งสองฝ่ายในด้านการค้า การลงทุน การพัฒนามาตรฐาน และการเชื่อมโยงเครือข่ายธุรกิจ โดยมีเป้าหมายสำคัญคือการสร้างโอกาสใหม่ให้ SME ไทยเข้าสู่ตลาดซาอุดีอาระเบีย ซึ่งมีขนาดตลาดใหญ่และกำลังเติบโตอย่างต่อเนื่อง`,
    images: [
      'https://iili.io/qFAZFRa.jpg', // image003
      'https://iili.io/qFAZgea.jpg', // image034
      'https://iili.io/qFAZ6zv.jpg', // image036
      'https://iili.io/qFAZisp.jpg', // image038
      'https://iili.io/qFAZZgt.jpg', // image039
    ]
  },
  {
    id: 20,
    title: 'ยกระดับ SME ไทยสู่ตลาดโลก ไทย–ซาอุฯ ลงนามความร่วมมือเชิงยุทธศาสตร์',
    content: `การลงนามบันทึกข้อตกลงความร่วมมือ (MOU) เมื่อวันที่ 9 มกราคม 2569 ระหว่างสมาพันธ์เอสเอ็มอีไทย นำโดย ดร.ณพพงศ์ ธีระวร และ คุณสมประสงค์ พยัคฆพันธ์ กับสภาธุรกิจซาอุดีอาระเบีย–ไทย นำโดย Mr. Osama Kokandy ถือเป็นอีกหมุดหมายสำคัญของการพัฒนา SME ไทยสู่เวทีสากล

Cluster SIE จะทำหน้าที่เป็นกลไกกลางในการรวมกลุ่มผู้ประกอบการ พัฒนาคุณภาพสินค้า และสร้างความเชื่อมโยงกับตลาดซาอุดีอาระเบียอย่างต่อเนื่อง เพื่อให้การเติบโตของ SME ไทยเป็นไปอย่างมั่นคง ยั่งยืน และสอดคล้องกับแนวโน้มเศรษฐกิจโลก`,
    images: [
      'https://iili.io/qFAZHKP.jpg', // image004
      'https://iili.io/qFAZfDv.jpg', // image006
      'https://iili.io/qFAZARs.jpg', // image014
      'https://iili.io/qFAZXbj.jpg', // image025
      'https://iili.io/qFAZQ1I.jpg', // image041
    ]
  },
]
